// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3qqsp","header":"Messages_header__2DIqE"};